<template>
    <v-layout class="hidden-sm-and-down not-logged-operations">
        <v-row class="justify-end mx-0">
            <v-col md="2" lg="auto" class="header-profile-btn-wrap px-1 px-lg-3 d-none d-md-flex justify-content-center">
                <v-btn
                    icon
                    fab
                    small
                    text
                    class="white--text"
                    link
                    to="/calculator"
                >
                    <v-icon>calculate</v-icon>
                </v-btn>
            </v-col>
            <v-col md="2" lg="auto" class="header-profile-btn-wrap px-1 px-md-3 d-flex justify-content-center">
                <v-badge color="teal" overlap :value="comparedCount">
                    <span slot="badge">{{ comparedCount }}</span>
                    <v-btn
                            icon
                            fab
                            small
                            text
                            class="white--text"
                            link
                            to="/products/compare"
                    >
                        <v-img
                                contain
                                :src="comparedIconPaths.comparedPageHeader"
                                :width="comparedIconSizes.width"
                                :height="comparedIconSizes.height"
                        ></v-img>
                    </v-btn>
                </v-badge>
            </v-col>
            <v-col md="2" lg="auto" class="header-profile-btn-wrap px-1 px-lg-3 d-sm-flex justify-content-center">
                <v-badge color="teal" overlap :value="noLoginBasketCount">
                    <span slot="badge">{{ noLoginBasketCount }}</span>
                    <v-btn
                            icon
                            fab
                            small
                            text
                            color="white"
                            to="/basket"
                    >
                        <v-icon>shopping_cart</v-icon>
                    </v-btn>
                </v-badge>
            </v-col>
            <v-col lg="auto" class="header-profile-btn-wrap px-1 px-lg-3 justify-content-center auth-buttons">
                <v-btn
                    text
                    small
                    depressed
                    class="text--white"
                    @click="$router.push('/login')"
                >
                    {{ $t('enter') }}
                </v-btn>
            </v-col>
        </v-row>
    </v-layout>
</template>

<script>
    import ProductsCompare from "../../mixins/ProductsCompare"
    import NoLoginBasket from "../../mixins/NoLoginBasket"

    export default {
        name: "NotLoggedOperations",
        mixins: [ProductsCompare, NoLoginBasket]
    }
</script>

<style scoped>

</style>
